import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      accessToken: "",
      account: "",
    };
  },
  mutations :{
    setAccessToken(state, token){
      state.accessToken = token
    }
  },
});

export default store;
